import React, { Component, PropTypes } from 'react';
import PageModule from '../PageModule';
import css from '../css';
import VideoModuleEditor from '../Edit/VideoModuleEditor';
import Video from 'cio/lib/Assets/Video';

const videoCss = oxygenCss({
  video: {
    position: 'relative',
    width: '100%'
  }
});

class VideoModule extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  render() {
    const { sources, caption, mode, ...other } = this.props;
    const hasSources = sources.length > 0;
    if (mode === 'edit') {
      return <VideoModuleEditor icon={<Video />} {...this.props} />;
    }
    return (
      <PageModule {...other}>
        <video controls className={videoCss.video}>
          {sources.map(source => {
            const extension = source.data.split('.').pop();
            return (
              <source
                src={source.data}
                type={`video/${extension}`}
                key={extension}
              />
            );
          })}
        </video>
        <figcaption>{caption}</figcaption>
      </PageModule>
    );
  }
}

export default VideoModule;



// WEBPACK FOOTER //
// ./src/js/module/View/VideoModule.js